<template>
	<form class="_form" :inert="loading" :disabled="loading" @submit="onFormSubmit">
		<template v-for="(field, index) in fields" :key="field.name || index">
			<component
				:is="getFieldComponent(field)"
				ref="fields"
				v-bind="field"
				:index="index + 1"
				:display-errors="displayErrors"
			/>
		</template>
		<!-- <div class="g-row">
			<div class="g-col xxl-8 xxl-offset-16 md-10 md-offset-14 sm-14 sm-offset-6 xs-18 xs-offset-5">
				<div class="submit-container relative">
					<FormButton :label="label" :inert="displayErrors && !valid" :loading="loading" />
					<Checkbox />
					<TextBlock v-if="displayErrors && !valid" class="error p-large background-white" :value="errorMessage" method="break" />
				</div>
			</div>
		</div> -->

		<div class="g-row">
			<div class="g-col xxl-6 md-4 sm-6 xs-5" />
			<div class="g-col xxl-10 md-10 sm-18 xs-19">
				<div class="submit-container relative">
					<div v-if="displayErrors && !valid" class="error -p-large background-white">
						<p v-for="(line, lineIndex) in errorLines" :key="lineIndex">{{ line }}</p>
					</div>
				</div>
			</div>
			<div
				class="-p-large -align-self-center g-col xxl-8 md-10 sm-18 sm-offset-6 xs-19 xs-offset-5"
			>
				<div class="submit-container relative">
					<FormButton :label="label" :inert="displayErrors && !valid" :loading="loading" />
					<Checkbox :display-errors="displayErrors && !valid" />

					<!-- <TextBlock v-if="displayErrors && !valid" class="error p-large background-white" :value="errorMessage" method="break" /> -->
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import { EmailField, SelectField, TextField, Checkbox } from './fields'
import FormButton from './Form.Button'

function createInitialValue(fields = []) {
	return fields.map(({ name, type }) => ({
		name,
		type,
		value: undefined,
		valid: false,
	}))
}

export default {
	components: { EmailField, FormButton, SelectField, TextField, Checkbox },
	provide() {
		return {
			$form: {
				setField: this.setField,
				pushPrivacy: this.pushPrivacy,
			},
		}
	},
	props: {
		fields: { type: Array, required: true },
		label: { type: String, default: 'Send' },
		action: { type: Function, default: () => {} },
		errorMessage: {
			type: String,
			default: 'You are not giving it all\nSick of the red? Please, fill everything to proceed',
		},
	},
	data() {
		return {
			valid: false,
			displayErrors: false,
			loading: false,
			value: createInitialValue(this.fields),
		}
	},
	computed: {
		errorLines() {
			return String(this.errorMessage || '').split('\n')
		},
	},
	methods: {
		setField(name, payload) {
			const index = this.value.findIndex((fields) => fields.name === name)

			if (index >= 0) {
				delete payload.name
				delete payload.type

				this.value[index] = {
					...this.value[index],
					...payload,
				}
			}

			const hasErrors = payload.valid === false || this.value.find((field) => !field.valid)

			this.valid = !hasErrors
		},
		pushPrivacy(name, payload) {
			const hasPrivacy = this.value.find((field) => field.name === name)

			if (hasPrivacy) {
				this.setField(name, payload)
				return
			}

			this.value.push({
				name,
				type: 'checkbox',
				value: payload.value,
				valid: payload.valid,
			})
		},
		getFieldComponent({ type }) {
			const dictionary = {
				email: 'EmailField',
				select: 'SelectField',
				text: 'TextField',
				string: 'TextField',
			}

			return dictionary[type] ?? 'span'
		},
		resetFormState(formElement) {
			this.valid = false
			this.displayErrors = false
			this.value = createInitialValue(this.fields)

			if (formElement && typeof formElement.reset === 'function') {
				formElement.reset()
			}
		},
		async onFormSubmit(event) {
			event.preventDefault()

			if (!this.valid) {
				this.displayErrors = true
				return
			}

			this.loading = true

			try {
				const submittedValue = this.value.map((field) => ({ ...field }))
				const body = JSON.stringify(submittedValue)

				const res = await fetch('/api/brevoSanity', {
					body,
					headers: {
						'Content-Type': 'application/json',
					},
					method: 'POST',
				})
				const payload = await res.json().catch(() => ({}))

				if (!res.ok || payload?.error) {
					console.log(payload?.error || 'Failed to submit form')
					return
				}

				this.$emit('submitted', {
					value: submittedValue,
					actionResponse: res,
				})

				this.resetFormState(event.target)
			} finally {
				this.loading = false
			}
		},
	},
}
</script>

<style lang="scss">
._form {
	--form-error-red: #dc3429;

	position: relative;
	margin-bottom: rs(144, 96);

	&[disabled] fieldset {
		opacity: 0.3;
	}

	fieldset {
		transition: opacity 0.4s ease('power2', 'inOut');
	}

	._form-checkbox-field {
		--color: #{$black};
	}

	button {
		position: relative;

		&[disabled] {
			visibility: hidden;
		}

		.underline {
			position: absolute;
			width: 100%;
			height: 0.066em;
			left: 0;
			bottom: -0.033em;

			background-color: $black;
		}
	}

	& > fieldset:last-of-type > ._form-field-layout {
		margin-bottom: 0;
	}

	.submit-container {
		margin-top: crs(104, 22);
	}

	.error {
		color: var(--form-error-red);

		& > p:not(:first-child) {
			@include p-large;
			margin-top: rs(10, 10);
		}
	}
}
</style>
